
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M3.95995 11.38C4.23995 9.91 5.61995 8.9 7.11995 8.9H10.05C10.57 8.9 11 8.47 11 7.95C11 7.43 10.57 7 10.05 7H7.21995C4.60995 7 2.27995 8.91 2.02995 11.51C1.73995 14.49 4.07995 17 6.99995 17H10.05C10.57 17 11 16.57 11 16.05C11 15.53 10.57 15.1 10.05 15.1H6.99995C5.08995 15.1 3.57995 13.36 3.95995 11.38ZM8.99995 13H15C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11H8.99995C8.44995 11 7.99995 11.45 7.99995 12C7.99995 12.55 8.44995 13 8.99995 13ZM16.78 7H13.95C13.43 7 13 7.43 13 7.95C13 8.47 13.43 8.9 13.95 8.9H16.88C18.38 8.9 19.76 9.91 20.04 11.38C20.42 13.36 18.91 15.1 17 15.1H13.95C13.43 15.1 13 15.53 13 16.05C13 16.57 13.43 17 13.95 17H17C19.92 17 22.26 14.49 21.98 11.51C21.73 8.91 19.39 7 16.78 7Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-insert-link`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconInsertLink

    ```js
    <b-new-b-icon-insert-link />
    ```
</docs>


